
<div class="modal-body-message-content">
    <app-normal-block-text2 class="mb-1" :text="date"></app-normal-block-text2>
    <app-normal-block-text class="mb-0" :text="description"></app-normal-block-text>
</div>
